<template>
    <div class="input-control">
        <div class="box" ref="box" tabindex="-1">
            <div class="item" v-for="(item, index) in options" :key="index"
                 :class="{selected: isItemSelected(item)}"
                 @click="onClickItem(item)"
            >
                <div class="item-content">
                    <i class="gf gf-success check-icon"></i><span>{{item.label}}</span>
                </div>
            </div>
            <div class="note">
                <template v-if="value.length">
                    {{value.length}} selected
                </template>
                <template v-else>None selected</template>
            </div>
        </div>
    </div>
</template>

<script>
    import InputControlBase from "@/InputControls/InputControlBase";

    export default {
        name: "SelectableBoxes",
        mixins: [InputControlBase],
        props: {
            options: Array
        },
        created() {
            if (!Array.isArray(this.value)) {
                this.value = [];
            }
        },
        methods: {
            repaintUI() {

            },
            setInputValue(value) {
                if (!Array.isArray(value)) {
                    throw new Error('the value should be an array:' + value);
                }
                this.value = value;
            },
            focus() {
                this.$refs.box.focus();
            },
            isItemSelected(item) {
                return this.selectionMaps.hasOwnProperty(item.value);
            },
            onClickItem(item) {
                if (this.isItemSelected(item)) {
                    this.value.splice(this.value.indexOf(item.value), 1)
                } else {
                    this.value.push(item.value);
                }
            },
        },
        computed: {
            selectionMaps() {
                const maps = {};
                this.value.forEach(v => {
                    maps[v] = 1;
                });
                return maps;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "input-controls";
    @import "../assets/variables";

    .box {
        border: 1px solid lightgray;
        border-radius: 4px;
        line-height: 20px;
        background-color: white;
        padding: 3px 0;

        &:focus {
            box-shadow: 0 0 0 3px rgba($primary-blue, 0.6);
            outline: none;
        }

        .note {
          font-weight: 600;
          font-size: 0.86em;
          color: gray;
          margin-left: 6px;
          margin-top: 3px;
        }

        .item {
            padding: 3px;
            cursor: pointer;
            &:hover {
                background-color: rgba(black, 0.08);
            }

            &.selected {
                .item-content {
                    .check-icon {
                        color: $primary-green;
                    }
                }
            }

            .item-content {
              display: flex;
              align-items: center;
              font-size: 0.95em;

              .check-icon {
                margin-right: 0.25rem;
                color: lightgray;
                font-size: 1.3em;
              }
            }
        }
    }
</style>
